import { safeFetch, fetchConfig, debounce } from "../utilities/utils"

class CartService {
  constructor() {
    this.items = Array.from(document.querySelectorAll(".cart-item"))
    this.items.forEach((item) => this.manageState(item))
    this.selectorsToUpdate = [
      ".cart-summary__header",
      "#cart-total-price",
      "#checkout",
      ".cart-summary__free-shipping",
    ]
    this.mainCartSelector = ".shopify-section.cart"
    this.miniCart = document.getElementById("mini-cart")
    this.itemsContainersSelector = ".cart-items-container, .cart__empty, .mini-cart--empty"
    this.parser = new DOMParser()
  }

  manageState(cartItem) {
    const id = cartItem.getAttribute("data-variant-id")
    const deleteItem = cartItem.querySelector(".cart-item-delete, .cart-item__remove")

    deleteItem.addEventListener("click", async () => {
      await this.changeCartItem({
        id,
        quantity: 0,
      })

      cartItem.remove()
    })

    const quantityInput = cartItem.querySelector('input[name="quantity"]')

    if (!quantityInput) return

    const qtyPlus = cartItem.querySelector('button[name="plus"]')
    const qtyMinus = cartItem.querySelector('button[name="minus"]')
    const qtyInput = cartItem.querySelector('input[name="quantity"]')

    let quantity = parseInt(quantityInput.value)

    qtyPlus.addEventListener("click", () => {
      quantity = quantity + 1
      quantityInput.value = quantity

      this.changeCartItem({
        id,
        quantity,
      })
    })

    qtyMinus.addEventListener("click", () => {
      quantity = quantity - 1
      quantityInput.value = quantity

      this.changeCartItem({
        id,
        quantity,
      })
    })

    qtyInput.addEventListener("change", (e) => {
      const inputQty = parseInt(e.target.value)
      if (inputQty > 0) {
        quantity = parseInt(e.target.value)

        this.changeCartItem({
          id,
          quantity,
        })
      } else {
        qtyInput.value = quantity
      }
    })

    qtyInput.addEventListener("keypress", (e) => {
      if ((e.which !== 8 && e.which !== 0 && e.which < 48) || e.which > 57) {
        e.preventDefault()
      }
    })
  }

  async changeCartItem(item) {
    const config = {
      ...fetchConfig(),
      body: JSON.stringify({
        line: +item.id,
        quantity: item.quantity,
        sections: "main-cart",
      }),
    }

    fetch(`${routes.cartChange}`, config)
      .then((response) => {
        return response.json()
      })
      .then((response) => {
        const updateCartUI = (content) => {
          const parsedCart = this.parser.parseFromString(content, "text/html")
          if (response.item_count === 0) {
            const mainCart = document.querySelector(this.mainCartSelector)
            if (mainCart) {
              mainCart.innerHTML = parsedCart.querySelector(this.mainCartSelector).innerHTML
            }

            this.renderElements(parsedCart)
          } else {
            this.renderItems(parsedCart)
          }
        }

        if (!response.sections || response.sections["main-cart"] === null) {
          // Try fetching section directly
          const mainCartSectionUrl = `${window.location.pathname}?section_id=main-cart`

          fetch(mainCartSectionUrl)
            .then((response) => response.text())
            .then((sectionHtml) => {
              updateCartUI(sectionHtml)
            })
        } else {
          updateCartUI(response.sections["main-cart"])
        }

        // Fetch section directly
        const mainNavigationSectionUrl = `${window.location.pathname}?section_id=navigation-main`

        fetch(mainNavigationSectionUrl)
          .then((response) => response.text())
          .then((navigationMainSectionContent) => {
            // Parse and render the updated mini cart items count
            const parsedNavigation = this.parser.parseFromString(
              navigationMainSectionContent,
              "text/html",
            )

            if (response.item_count === 0) {
              const miniCart = document.querySelector("#mini-cart")

              if (miniCart) {
                miniCart.innerHTML = parsedNavigation.querySelector("#mini-cart").innerHTML
                miniCart.addEventListeners()
                miniCart.querySelectorAll(".icon").forEach((icon) => icon.classList.add("loaded"))
              }
            }
          })
      })
      .catch((error) => {
        console.error(error)
      })
  }

  renderElements(section) {
    this.selectorsToUpdate.forEach((selector) => {
      try {
        const elements = document.querySelectorAll(selector)
        const update = section.querySelector(selector)

        if (elements.length && update) {
          elements.forEach((element) => {
            update.querySelectorAll(".icon").forEach((icon) => icon.classList.add("loaded"))
            element.replaceWith(update.cloneNode(true))
          })
        }
      } catch (e) {
        console.error(`Error updating ${selector}`, e)
      }
    })

    const count = section.querySelector(".cart-count")

    document
      .querySelectorAll("#cart-open-block .header__icons--cart-open .cart-count")
      .forEach((node) => {
        if (count) {
          if (node.classList.contains("visually-hidden")) node.classList.remove("visually-hidden")
          node.textContent = count.textContent
        } else {
          node.classList.add("visually-hidden")
        }
      })

    document.querySelector("#cart-open-block .icon").classList.add("loaded")
  }

  renderItems(section) {
    this.renderElements(section)

    const containers = Array.from(document.querySelectorAll(this.itemsContainersSelector))

    const parsedContainer = section.querySelector(this.itemsContainersSelector)

    containers.forEach((element) => {
      if (element) element.replaceWith(parsedContainer.cloneNode(true))
    })
    const items = document.querySelectorAll(".cart-item")

    items.forEach((item) => {
      item.querySelectorAll(".icon").forEach((icon) => icon.classList.add("loaded"))
      this.manageState(item)
    })
  }

  updateMiniCart(openOnUpdate) {
    return fetch("/?section_id=main-cart")
      .then((response) => response.text())
      .then((responseText) => {
        this.renderItems(new DOMParser().parseFromString(responseText, "text/html"))

        if (openOnUpdate && cartStrings.uxCart === "mini-cart" && this.miniCart) {
          this.miniCart.open()
        }
      })
      .catch((error) => {
        console.error("Error updating mini cart:", error)
      })
  }
}

const cartService = new CartService()

export default cartService

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super()

        const note = this.querySelector("textarea")

        note.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value })
            fetch(`${routes.cartUpdate}`, {
              ...fetchConfig(),
              ...{ body },
            })
          }, 300),
        )
      }
    },
  )
}
